import { useKeycloak } from '@react-keycloak/web'
import { object } from 'prop-types'
import { useContext, useEffect } from 'react'
import { PermissionsContext } from '../providers/permissions'

const PrivateRoute = ({ children }) => {
  const { keycloak, initialized } = useKeycloak()

  const { setToken } = useContext(PermissionsContext)
  const isLogged = keycloak.authenticated

  if (isLogged === false) {
    keycloak?.login()
  }

  useEffect(() => {
    if (keycloak && initialized) {
      keycloak.onTokenExpired = () => keycloak.updateToken(100)
    }

    setToken(keycloak.token || '')
  }, [initialized, keycloak])

  localStorage.setItem('token', keycloak.token)

  return isLogged ? children : null
}
PrivateRoute.propTypes = {
  children: object
}
export default PrivateRoute
